import React from 'react'
import { Treemap } from 'react-vis'
import { EExpenseLevel } from '../../../typings'

interface Props {
	title: string
	dimensions: [number, number]
	data: Charts.TreemapData
	style?: React.CSSProperties
	onLeafClick?(leaf: any): void
	onLeafMouseOver?(leaf: any): void
}

const Test: React.FC<Props> = ({
	title,
	dimensions: [width, height],
	data,
	style,
	onLeafClick,
	onLeafMouseOver,
}) => (
	<div style={style}>
		<Treemap
			colorType='literal'
			title={title}
			width={width}
			height={height}
			hideRootNode={false}
			data={data}
			onLeafClick={onLeafClick}
			onLeafMouseOver={onLeafMouseOver}
			sortFunction={(a, b) => {
				switch (a.data.level) {
					case EExpenseLevel.Federal:
						return b.data.realTitle - a.data.realTitle

					case EExpenseLevel.Quarter:
						return a.data.realTitle - b.data.realTitle

					case EExpenseLevel.Institution:
						return b.data.size - a.data.size

					case EExpenseLevel.Entity:
						return b.data.size - a.data.size

					case EExpenseLevel.Program:
						return b.data.size - a.data.size

					default:
						return 0
				}
			}}
		/>
	</div>
)

export default Test
